import pageView from './page-view'
import { adsConfigSlotReady, adElementIds } from './ads-config-slot-ready'

export default {
  pageView,
  adsConfigSlotReady,
  adElementIds,
}
